import React from 'react'
import Slider from 'react-slick';
import { useInView } from 'react-intersection-observer';
import './WhyTelegram.scss'
import Deco1 from '../Assets/Images/ads1.webp';
import Deco2 from '../Assets/Images/ads2.webp';
import Deco3 from '../Assets/Images/ads3.webp';
import Deco4 from '../Assets/Images/ads4.webp';
import Deco5 from '../Assets/Images/ads5.webp';
import ArrowBack from '../Assets/Icons/arrow_back.svg';
import ArrowNext from '../Assets/Icons/arrow_next.svg';
import { useLanguage } from '../Contexts/LanguageContext';



const WhyTelegram = () => {
  const { language } = useLanguage();
  const { ref: ref1, inView: v1 } = useInView({ threshold: 0.2, triggerOnce: false });
  const { ref: ref2, inView: v2 } = useInView({ threshold: 0.2, triggerOnce: false });
  const { ref: ref3, inView: v3 } = useInView({ threshold: 0.2, triggerOnce: false });
  const { ref: ref4, inView: v4 } = useInView({ threshold: 0.2, triggerOnce: false });
  const { ref: ref5, inView: v5 } = useInView({ threshold: 0.2, triggerOnce: false });
  const { ref: ref6, inView: v6 } = useInView({ threshold: 0.4, triggerOnce: true });
  const { ref: ref7, inView: v7 } = useInView({ threshold: 0.4, triggerOnce: true });
  const { ref: ref8, inView: v8 } = useInView({ threshold: 0.4, triggerOnce: true });
  const { ref: ref9, inView: v9 } = useInView({ threshold: 0.4, triggerOnce: true });
  const { ref: ref10, inView: v10 } = useInView({ threshold: 0.4, triggerOnce: true });

  
  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
      className={className}
      onClick={onClick}
      >
        <img src={ArrowNext} alt="Następny" />
      </div>
    );
  }

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
        >
          <img src={ArrowBack} alt="Poprzedni" />
          </div>
      );
    }
    
    const settings = {
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
      pauseOnFocus: true,
      pauseOnHover: true,
      cssEase: "ease-in-out",
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    }

    return (
    <div className='why-telegram' id='dlaczego-telegram'>
      <h2>{language === 'polish' ? 'Dlaczego Telegram?' : 'Why Telegram?'}</h2>
      <h3>{language === 'polish' ? 'Dlaczego jesteśmy lepsi niż tradycyjne sieci DSP / pop traffic:' : 'Why we are better than traditional DSP / pop traffic networks:'}</h3>

      <div className='content-frame frame1 desktop-only'>
        <div ref={ref6} className={`content-left text-container ${v6 ? 'anim2' : ''}`}>
          <h3>{language === 'polish' ? 'Brak nachalnych pop-upów' : 'No intrusive pop-ups'}</h3>
          <p>{language === 'polish' ? 'Docieraj do zaangażowanych użytkowników w naturalny sposób – Twoje reklamy wyświetlają się bez uciążliwych okien, co przekłada się na lepszą percepcję marki i wyższy współczynnik konwersji.' : 'Reach engaged users naturally – your ads are displayed without annoying windows, leading to better brand perception and higher conversion rates.'}</p>
        </div>
        <div className='content-right image-container'>
          <img src={Deco1} ref={ref1} className={`deco deco1 ${v1 ? 'anim1' : ''}`} alt='' />

        </div>

      </div>

      <div className='content-frame frame2 desktop-only'>
        <div className='content-left image-container'>
          <img src={Deco2} ref={ref2} className={`deco deco2 ${v2 ? 'anim1' : ''}`} alt='' />
        </div>
        <div ref={ref7} className={`content-left text-container ${v7 ? 'anim2' : ''}`}>
          <h3>{language === 'polish' ? 'Żadnego przypadkowego ruchu (boty, incentivized)' : 'No random traffic (bots, incentivized)'}</h3>
          <p>{language === 'polish' ? 'Skieruj swoje reklamy wyłącznie do prawdziwych użytkowników – eliminujemy boty i ruch motywowany nagrodami, aby każda złotówka z budżetu przekładała się na realne zaangażowanie i konwersje.' : 'Direct your ads exclusively to real users – we eliminate bots and incentivized traffic, ensuring that every zloty of your budget translates into real engagement and conversions.'}</p>

        </div>
      </div>

      <div className='content-frame frame3 desktop-only'>
        <div ref={ref8} className={`content-left text-container ${v8 ? 'anim2' : ''}`}>
          <h3>{language === 'polish' ? 'Prawdziwe społeczności i zaangażowani użytkownicy' : 'Real communities and engaged users'}</h3>
          <p>{language === 'polish' ? 'Docieraj do zweryfikowanych grup tematycznych o wysokiej aktywności – Twoje reklamy trafiają do ludzi naprawdę zainteresowanych treścią, co przekłada się na trwałe relacje i lepsze wyniki kampanii.' : 'Reach verified interest-based groups with high activity – your ads reach people who are genuinely interested in the content, leading to lasting relationships and better campaign results.'}</p>
        </div>
        <div className='content-right image-container'>
          <img src={Deco3} ref={ref3} className={`deco deco3 ${v3 ? 'anim1' : ''}`} alt='' />

        </div>
      </div>

      <div className='content-frame frame4 desktop-only'>
        <div className='content-left image-container'>
          <img src={Deco4} ref={ref4} className={`deco deco4 ${v4 ? 'anim1' : ''}`} alt='' />
        </div>
        <div ref={ref9} className={`content-left text-container ${v9 ? 'anim2' : ''}`}>
          <h3>{language === 'polish' ? 'Możliwość reklam natywnych, pełnoekranowych i z nagrodą' : 'Native, fullscreen, and rewarded ad options'}</h3>
          <p>{language === 'polish' ? 'Dopasuj format kampanii do swoich celów – od subtelnych reklam natywnych, przez angażujące pełnoekranowe, aż po motywowane wideo z nagrodami, które zwiększają zaangażowanie i satysfakcję odbiorców.' : 'Customize your campaign format to your goals – from subtle native ads to engaging fullscreen ones, to rewarded video ads that boost engagement and audience satisfaction.'}</p>

        </div>
      </div>

      <div className='content-frame frame5 desktop-only'>
        <div ref={ref10} className={`content-left text-container ${v10 ? 'anim2' : ''}`}>
          <h3>{language === 'polish' ? 'Najwyższy CTR wśród platform mobilnych (Telegram usage rate +60%)' : 'Highest CTR among mobile platforms (Telegram usage rate +60%)'}</h3>
          <p>{language === 'polish' ? 'Wykorzystaj fakt, że ponad 60% użytkowników korzysta z Telegramu na urządzeniach mobilnych – to przekłada się na CTR przewyższający wszystkie inne platformy.' : 'Leverage the fact that over 60% of users access Telegram on mobile devices – this translates to a CTR that surpasses all other platforms.'}</p>
        </div>
        <div className='content-right image-container'>
          <img src={Deco5} ref={ref5} className={`deco deco5 ${v5 ? 'anim1' : ''}`} alt='' />

        </div>
      </div>

      <div className='mobile-only mobile-content'>
        <div className="slider-container">
          <Slider {...settings}>
            <div className='why-telegram-slide'>
              <div className='slide-number'>
                <h2>1</h2>
              </div>
              <img src={Deco1} alt='' />
              <h3>{language === 'polish' ? 'Brak nachalnych pop-upów' : 'No intrusive pop-ups'}</h3>
              <p>{language === 'polish' ? 'Docieraj do zaangażowanych użytkowników w naturalny sposób – Twoje reklamy wyświetlają się bez uciążliwych okien, co przekłada się na lepszą percepcję marki i wyższy współczynnik konwersji.' : 'Reach engaged users naturally – your ads appear without annoying windows, leading to better brand perception and higher conversion rates.'}</p>
            </div>
            <div className='why-telegram-slide'>
              <div className='slide-number'>
                <h2>2</h2>
              </div>
              <img src={Deco2} alt='' />
              <h3>{language === 'polish' ? 'Żadnego przypadkowego ruchu (boty, incentivized)' : 'No accidental traffic (bots, incentivized)'}</h3>
              <p>{language === 'polish' ? 'Skieruj swoje reklamy wyłącznie do prawdziwych użytkowników – eliminujemy boty i ruch motywowany nagrodami, aby każda złotówka z budżetu przekładała się na realne zaangażowanie i konwersje.' : 'Target your ads exclusively to real users – we eliminate bots and incentivized traffic, ensuring that every zloty of your budget translates into genuine engagement and conversions.'}</p>
            </div>

            <div className='why-telegram-slide'>
              <div className='slide-number'>
                <h2>3</h2>
              </div>
              <img src={Deco3} alt='' />
              <h3>{language === 'polish' ? 'Prawdziwe społeczności i zaangażowani użytkownicy' : 'Real communities and engaged users'}</h3>
              <p>{language === 'polish' ? 'Docieraj do zweryfikowanych grup tematycznych o wysokiej aktywności – Twoje reklamy trafiają do ludzi naprawdę zainteresowanych treścią, co przekłada się na trwałe relacje i lepsze wyniki kampanii.' : 'Reach verified interest-based groups with high activity – your ads reach people who are genuinely interested in the content, leading to lasting relationships and better campaign results.'}</p>
            </div>
            <div className='why-telegram-slide'>
              <div className='slide-number'>
                <h2>4</h2>
              </div>
              <img src={Deco4} alt='' />
              <h3>{language === 'polish' ? 'Możliwość reklam natywnych, pełnoekranowych i z nagrodą' : 'Native, fullscreen, and rewarded ad options'}</h3>
              <p>{language === 'polish' ? 'Dopasuj format kampanii do swoich celów – od subtelnych reklam natywnych, przez angażujące pełnoekranowe, aż po motywowane wideo z nagrodami, które zwiększają zaangażowanie i satysfakcję odbiorców.' : 'Tailor your campaign format to your goals – from subtle native ads to engaging fullscreen experiences, to rewarded video content that boosts engagement and audience satisfaction.'}</p>
            </div>
            <div className='why-telegram-slide'>
              <div className='slide-number'>
                <h2>5</h2>
              </div>
              <img src={Deco5} alt='' />
              <h3>{language === 'polish' ? 'Najwyższy CTR wśród platform mobilnych (Telegram usage rate +60 %)' : 'Highest CTR among mobile platforms (Telegram usage rate +60%)'}</h3>
              <p>{language === 'polish' ? 'Wykorzystaj fakt, że ponad 60% użytkowników korzysta z Telegramu na urządzeniach mobilnych – to przekłada się na CTR przewyższający wszystkie inne platformy.' : 'Leverage the fact that over 60% of users access Telegram on mobile devices – this translates to a CTR that surpasses all other platforms.'}</p>
            </div>

          </Slider>
        </div>
      </div>

    </div>
  )
}

export default WhyTelegram